import { render } from "./RoundSpectator.vue?vue&type=template&id=27ce371a&scoped=true"
import script from "./RoundSpectator.vue?vue&type=script&lang=js"
export * from "./RoundSpectator.vue?vue&type=script&lang=js"

import "./RoundSpectator.vue?vue&type=style&index=0&id=27ce371a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ce371a"]])

export default __exports__